/**
 * NaN, Infinity are NOT considered as numbers.
 */
export function isNumberFormat(value: string | number): boolean {
  if (typeof value === "number" && !Number.isNaN(value) && Number.isFinite(value)) {
    return true;
  }

  if (value == null) {
    return false;
  }

  // without trim, Number(" ") == 0, which is wrong.
  if (typeof value === "string" && value.trim() === "") {
    return false;
  }

  try {
    const n = Number(value);
    return !Number.isNaN(n) && Number.isFinite(n);
  } catch {
    return false;
  }
}
